export default __webpack_public_path__ + "static/media/person.7ac88647.png";